export enum PathName {
  uploader = 'PATIENT_LIST',
  about = 'ABOUT',
  fmx = 'FMX_VIEW',
  single_image_view = 'SINGLE_IMAGE_VIEW',
  other = 'OTHER',
  process_historical = 'PROCESS_HISTORICAL',
}

export type OpenWidgetEvent = {
  currentPage: PathName;
  patientId?: string;
  imageId?: string;
};

export enum CustomerSupportInfoTypes {
  phoneNumber = 'PHONE_NUMBER',
  email = 'EMAIL',
}

export type CopyTextEvent = {
  copiedValue: CustomerSupportInfoTypes;
};
